/**
 * CartIndicator.jsx
 * Created by Hassan Riaz on 1/16/20.
 */

import React from 'react';
import { get } from 'lodash';

import * as Icons from './icons/Icons';
import CartTimer from './CartTimer';
import { pluralize } from '../../helpers/stringHelper';

import { CART_HEADER_PROPS } from '../navigation/constants';

export default class CartIndicator extends React.PureComponent {
    static propTypes = {
        cart: CART_HEADER_PROPS,
    };

    static defaultProps = {
        cart: {
            showTimer: false,
            reservation_count: 0,
        },
    };

    render() {
        const numCartItems = get(this.props, 'cart.reservation_count', 0);

        const cartAriaLabel =
            numCartItems > 0
                ? `Cart - ${numCartItems} ${pluralize(
                      numCartItems,
                      'item',
                      'items'
                  )} in cart.`
                : 'Cart';

        return (
            <React.Fragment>
                <a
                    aria-label={cartAriaLabel}
                    href="/cart"
                    className="nav-interactions-link nav-interactions-link-cart"
                >
                    <Icons.IconCart />
                    {numCartItems > 0 && (
                        <span className="cart-quantity">{numCartItems}</span>
                    )}
                </a>
                {this.props.cart.showTimer && (
                    <div className="rec-small-timer">
                        <CartTimer date={new Date(this.props.cart.expiration)} />
                    </div>
                )}
            </React.Fragment>
        );
    }
}
